// 智能辅助审核结果：-1 审核失败 1 建议通过 / 2 建议驳回 / 3 建议存疑
export enum AiAuditResult {
  Failed = -1,
  Pass = 1,
  Reject = 2,
  Doubt = 3
}

export const AI_AUDIT_RESULT = {
  [AiAuditResult.Failed]: {
    label: '审核失败',
    value: AiAuditResult.Failed,
    tagType: 'error'
  },
  [AiAuditResult.Pass]: {
    label: '建议通过',
    value: AiAuditResult.Pass,
    tagType: 'success'
  },
  [AiAuditResult.Reject]: {
    label: '建议驳回',
    value: AiAuditResult.Reject,
    tagType: 'danger'
  },
  [AiAuditResult.Doubt]: {
    label: '建议存疑',
    value: AiAuditResult.Doubt,
    tagType: 'warning'
  }
};
